import { default as React, FC, useEffect } from 'react';

export const HasUnsavedChangesConfirmation: FC<{ isDirty: boolean }> = ({ isDirty }) => {
	useEffect(() => {
		isDirty ? AddConfirmation() : RemoveConfirmation();
	}, [isDirty]);

	return <></>;
};

const AddConfirmation = () => {
	RemoveConfirmation();
	window.addEventListener('beforeunload', onUnload);
};

const RemoveConfirmation = () => {
	window.removeEventListener('beforeunload', onUnload);
};

const onUnload = (event: any) => {
	// Cancel the event as stated by the standard.
	event.preventDefault();
	// Chrome requires returnValue to be set.
	event.returnValue = '';
};
